// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { saveScheduledLinesApi, ScheduledItem } from "@eisinc/App/Services/ScheduleOrderService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";


export interface ScheduleModel {
    productId: string,
    unitOfMeasure: string,
    items: ScheduledItem[];
}

export interface SaveScheduledLinesParameter {
    model: SchedulesModel;
    onSuccess?: () => void;
}
export interface SchedulesModel {
    shipAsapAll?: boolean;
    shipOneRequestedDateAll?: boolean;
    oneRequestedDate?: Date | string;
    schedules: ScheduleModel[];
    isScheduledorderPage?: boolean;
}

type HandlerType = ApiHandlerDiscreteParameter<SaveScheduledLinesParameter, any>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter.model;
};

export const SendDataToApi: HandlerType = async props => {
    await saveScheduledLinesApi(props.apiParameter);
};

export const LoadCart: HandlerType = props => {
    if (!props.apiParameter?.model?.isScheduledorderPage) {
        const state = props.getState();
        const { cartId } = state.pages.checkoutShipping;
        if (cartId) {
            props.dispatch(loadCart({ cartId }));
        } else {
            props.dispatch(loadCurrentCart({ getPromotions: true }));
        }
    }

};


export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, LoadCart, ExecuteOnSuccessCallback];

const saveScheduledLines = createHandlerChainRunner(chain, "SaveScheduledLines");
export default saveScheduledLines;
